import React from 'react';
import SimpleValuePicker from '../SelectorManagees/SimpleValuePicker';
import { YearFilterManageeProps } from './helpers/yearManagees';

function RegularYearPicker({
    children,
    isPerimeterFilter,
    filter,
    setFilter,
    shouldDebounce,
    inputProps,
}: YearFilterManageeProps): React.ReactElement {
    if (isPerimeterFilter && !filter.value) return children;
    return (
        <>
            {children}

            <SimpleValuePicker
                filter={filter}
                setFilter={setFilter}
                isPerimeterFilter={isPerimeterFilter}
                shouldDebounce={shouldDebounce}
                inputProps={inputProps}
            />
        </>
    );
}
export default RegularYearPicker;
